import { configureStore } from '@reduxjs/toolkit';

// import globalReducer from './global/globalSlice';

// 临时的空 reducer，避免 Redux 报错
const dummyReducer = (state = {}) => state;

const store = configureStore({
  reducer: {
    dummy: dummyReducer,
    // global: globalReducer,
  }
});

export default store;
